import React from 'react';
import { Play } from 'lucide-react';

function VideoPlayer({ videoUrl, productName }) {
  if (!videoUrl) return null;

  const getVideoEmbedUrl = (url) => {
    // YouTube
    if (url.includes('youtube.com') || url.includes('youtu.be')) {
      const videoId = url.includes('youtu.be') 
        ? url.split('youtu.be/')[1]?.split('?')[0]
        : url.split('v=')[1]?.split('&')[0];
      return `https://www.youtube.com/embed/${videoId}`;
    }
    
    // Vimeo
    if (url.includes('vimeo.com')) {
      const videoId = url.split('vimeo.com/')[1]?.split('?')[0];
      return `https://player.vimeo.com/video/${videoId}`;
    }
    
    // Direct video file
    if (url.endsWith('.mp4') || url.endsWith('.webm') || url.endsWith('.mov')) {
      return url;
    }
    
    return null;
  };

  const embedUrl = getVideoEmbedUrl(videoUrl);
  const isDirectVideo = embedUrl?.includes('.mp4') || embedUrl?.includes('.webm') || embedUrl?.includes('.mov');

  if (!embedUrl) return null;

  return (
    <div className="relative w-full rounded-2xl overflow-hidden border border-white/10 bg-neutral-900 mb-8" data-testid="video-demo-player">
      <div className="aspect-video relative">
        {isDirectVideo ? (
          <video
            controls
            className="w-full h-full"
            poster={`${embedUrl}#t=0.1`}
          >
            <source src={embedUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <iframe
            src={embedUrl}
            title={`${productName} Demo`}
            className="w-full h-full"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        )}
      </div>
      <div className="absolute top-4 right-4 bg-[#00F0FF] text-black px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1">
        <Play className="w-3 h-3" />
        DEMO
      </div>
    </div>
  );
}

export default VideoPlayer;
